import { v7 as uuidv7 } from 'uuid'

export function useUUIDGenerate (): string {
  return uuidv7()
}
